'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactScroll = require('react-scroll');
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);
var _reduxForm = require('redux-form');
var _components = require('../../components');

var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);
var _formatVirtualNumberOptions = require('../../utils/formatVirtualNumberOptions');var _formatVirtualNumberOptions2 = _interopRequireDefault(_formatVirtualNumberOptions);
var _getVirtualNumberValue = require('../../utils/getVirtualNumberValue');
var _PublishPropertyForm = require('../../containers/PublishForm/PublishPropertyForm.scss');var _PublishPropertyForm2 = _interopRequireDefault(_PublishPropertyForm);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Helpers

var required = function required(value) {return value ? undefined : 'Required';};

var SHOULD_RENDER_EMAIL = false;var

PublishContactsBlock = function (_Component) {_inherits(PublishContactsBlock, _Component);function PublishContactsBlock() {var _temp, _this, _ret;_classCallCheck(this, PublishContactsBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isShownSecondaryContact: !!_this.props.secondaryContact }, _this.









    handleContacts = function () {var
      isShownSecondaryContact = _this.state.isShownSecondaryContact;
      if (isShownSecondaryContact) {
        _this.props.changeValue('contacts', { primary: _this.props.primaryContact });
      } else {
        _this.props.untouch(
        'contacts.secondary.name',
        'contacts.secondary.email',
        'contacts.secondary.phone',
        'contacts.secondary.realtor_id');

        _this.props.unregisterFormField('contacts.secondary');
      }
      _this.setState({ isShownSecondaryContact: !isShownSecondaryContact });
    }, _this.

    handleVirtualNumberChange = function (type) {return function (_ref) {var value = _ref.value,name = _ref.name,realtor_id = _ref.realtor_id;
        var isOtherOption = value === _getVirtualNumberValue.OTHER_OPTION_VALUE;
        var newPhoneValue = isOtherOption ? null : value;
        var newNameValue = isOtherOption ? null : name;

        _this.props.changeValue('contacts.' + type, {
          realtor_id: realtor_id,
          phone: newPhoneValue,
          name: newNameValue,
          virtual: value });

      };}, _this.

    formatOptions = function () {var _this$props =
      _this.props,virtualNumbers = _this$props.virtualNumbers,isRtl = _this$props.isRtl,translate = _this$props.translate;
      var title = _react2.default.createElement('span', { className: _PublishPropertyForm2.default.virtualNumberTitle }, translate('virtualNumber'));
      var options = (0, _formatVirtualNumberOptions2.default)(virtualNumbers, isRtl, title);
      // options.push({ label: translate(OTHER_OPTION_VALUE).toString(), value: OTHER_OPTION_VALUE, name: null });

      return options;
    }, _this.

    filterOptions = function (removedType) {
      var virtual = (0, _get2.default)('contacts.' + removedType + '.virtual', _this.props);

      var options = _this.formatOptions();

      if (virtual) {
        return options.filter(function (item) {return item.value !== virtual;});
      }

      return options;
    }, _this.

    renderVirtualNumbers = function (type) {return (
        _react2.default.createElement('div', { className: _PublishPropertyForm2.default.virtualNumberRow },
          _react2.default.createElement('span', { className: 'label' }, _this.props.translate('contactPerson'), '\xA0',
            _react2.default.createElement('span', { className: 'req' }, '*')),

          _react2.default.createElement(_reduxForm.Field, {
            name: 'contacts.' + type + '.virtual',
            props: { locale: _this.props.locale, type: type },
            component: _this.renderSelect,
            validate: [required] })));}, _this.




    renderSelect = function (_ref2) {var input = _ref2.input,meta = _ref2.meta,type = _ref2.type;
      var shouldShowError = meta.touched && meta.error && !meta.active;

      var optionsPrimary = _this.filterOptions('secondary');
      var optionsSecondary = _this.filterOptions('primary');

      return (
        _react2.default.createElement('div', { className: _PublishPropertyForm2.default.virtualNumberWrap },
          _react2.default.createElement(_reactSelect2.default, _extends({},
          input, {
            options: input.name === 'contacts.secondary.virtual' ? optionsSecondary : optionsPrimary,
            onChange: _this.handleVirtualNumberChange(type),
            searchable: false,
            clearable: false,
            instanceId: 'publish',
            rtl: _this.props.isRtl,
            placeholder: _this.props.translate('virtualNumberPlaceholder').toString(),
            className: (0, _classnames2.default)(_PublishPropertyForm2.default.numbersSelect,
            { not_valid: shouldShowError }) })),

          shouldShowError &&
          _react2.default.createElement('span', { className: _PublishPropertyForm2.default.numberError }, _this.props.translate('selectContact'))));



    }, _this.

    renderEmail = function (_ref3) {var input = _ref3.input,meta = _ref3.meta;var
      error = meta.error,touched = meta.touched;
      var isInvalid = error === 'Required' && touched;
      return (
        _react2.default.createElement(_components.OMInputField, _extends({
          type: 'text' },
        input, {
          placeholder: '' + _this.props.translate('email'),
          tooltipMessage: '' + _this.props.translate('emailTooltipMessage'),
          showHoverTooltip: isInvalid,
          isInvalid: isInvalid,
          isMobile: _this.props.isMobile,
          isRtl: _this.props.isRtl })));


    }, _this.

    renderContactsRow = function (type) {var _cx;
      var contactNameError = (0, _get2.default)(_this.props.contactsErrors, type + '.name');
      var isValidName = !(contactNameError && contactNameError === 'invalid-char');
      var shouldRenderTitle = (0, _get2.default)(_this.props, type + 'Contact.virtual') !== _getVirtualNumberValue.OTHER_OPTION_VALUE;
      var emptyLabel = !_this.props.isMobile && _react2.default.createElement('span', { className: 'label' }, '\xA0');

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_PublishPropertyForm2.default.requiredFieldWrapper, _PublishPropertyForm2.default.contactData) },
          shouldRenderTitle ?

          _react2.default.createElement('span', { className: 'label' }, _this.props.translate('contactPerson'), '\xA0',
            _react2.default.createElement('span', { className: 'req' }, '*')) :

          emptyLabel,

          _react2.default.createElement('div', { className: (0, _classnames2.default)('fieldset', _PublishPropertyForm2.default.contactsInputWrapper, (_cx = {}, _cx[_PublishPropertyForm2.default.invalidName] = !isValidName, _cx)) },
            _react2.default.createElement('div', { className: _PublishPropertyForm2.default.dataRow },
              _react2.default.createElement('div', { className: (0, _classnames2.default)(_PublishPropertyForm2.default.contactInput, _PublishPropertyForm2.default.requiredFieldWrapper) },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'contacts.' + type + '.name',
                  props: { locale: _this.props.locale },
                  component: _this.renderInput,
                  validate: [required] }),

                _this.props.isMobile && _this.props.locale === 'ru' && !isValidName &&
                _react2.default.createElement('div', { style: { height: '15px' } })),


              _react2.default.createElement('div', { className: (0, _classnames2.default)(_PublishPropertyForm2.default.contactInput, _PublishPropertyForm2.default.requiredFieldWrapper) },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'contacts.' + type + '.phone',
                  props: { locale: _this.props.locale },
                  normalize: _publish2.default.phone,
                  component: _this.renderInput,
                  validate: [required] }))),



            !isValidName &&
            _react2.default.createElement('span', { className: _PublishPropertyForm2.default.textError }, _this.props.translate('invalidContactNameCharacter')))));





    }, _this.

    renderInput = function (_ref4) {var input = _ref4.input,meta = _ref4.meta;return (
        _react2.default.createElement('input', _extends({},
        input, {
          type: 'text',
          placeholder: _this.props.translate(input.name.split('.')[2]),
          className: (0, _classnames2.default)(_PublishPropertyForm2.default.numeric, 'form-control',
          { not_valid: meta.touched && meta.error && !meta.active }) })));}, _temp), _possibleConstructorReturn(_this, _ret);}PublishContactsBlock.prototype.componentDidMount = function componentDidMount() {if (this.props.secondaryContact) {var virtual = (0, _getVirtualNumberValue.getVirtualNumberValue)(this.props.secondaryContact, this.props.virtualNumbers);this.props.changeValue('contacts.secondary', Object.assign({}, this.props.secondaryContact, { virtual: virtual }));}};PublishContactsBlock.prototype.



  renderContactsFields = function renderContactsFields(type) {var
    virtualNumbers = this.props.virtualNumbers;
    var shouldRenderVirtualNumbers = !!(virtualNumbers && virtualNumbers.length);

    return (
      _react2.default.createElement('div', { className: _PublishPropertyForm2.default.requiredFieldWrapper },
        _react2.default.createElement('div', null,
          shouldRenderVirtualNumbers ? this.renderVirtualNumbers(type) : this.renderContactsRow(type),
          (0, _get2.default)(this.props, type + 'Contact.virtual') === _getVirtualNumberValue.OTHER_OPTION_VALUE && this.renderContactsRow(type),

          SHOULD_RENDER_EMAIL &&
          _react2.default.createElement('div', { className: _PublishPropertyForm2.default.requiredFieldWrapper },
            !this.props.isMobile &&
            _react2.default.createElement('span', { className: 'label' }, this.props.translate('email'), '\xA0'),



            _react2.default.createElement('div', { className: 'fieldset' },
              _react2.default.createElement(_reduxForm.Field, {
                name: 'contacts.' + type + '.email',
                props: { locale: this.props.locale },
                component: this.renderEmail }))))));







  };PublishContactsBlock.prototype.

  render = function render() {var _cx2;var
    virtualNumbers = this.props.virtualNumbers;var
    isShownSecondaryContact = this.state.isShownSecondaryContact;

    var options = this.formatOptions();
    var isVirtualNumbers = virtualNumbers && virtualNumbers.length;

    return (
      _react2.default.createElement(_reactScroll.Element, { name: 'contacts', className: _PublishPropertyForm2.default.sectionBlock },
        _react2.default.createElement('div', { className: _PublishPropertyForm2.default.title }, this.props.translate('sections', 'contacts')),

        _react2.default.createElement('div', { className: (0, _classnames2.default)(_PublishPropertyForm2.default.contactsWrapper, (_cx2 = {}, _cx2[_PublishPropertyForm2.default.hiddenContact] = !isShownSecondaryContact, _cx2)) },
          this.renderContactsFields('primary'),
          isShownSecondaryContact && this.renderContactsFields('secondary')),

        (options && options.length > 1 || !isVirtualNumbers) &&
        _react2.default.createElement('div', {
            className: _PublishPropertyForm2.default.addContact,
            onClick: this.handleContacts },

          _react2.default.createElement('span', { className: 'icon icon-' + (isShownSecondaryContact ? 'hide' : 'publish') }),
          this.props.translate('' + (isShownSecondaryContact ? 'removeContact' : 'addContact')))));




  };return PublishContactsBlock;}(_react.Component);


PublishContactsBlock.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  changeValue: _propTypes2.default.func,
  virtualNumbers: _propTypes2.default.array,
  primaryContact: _propTypes2.default.object,
  secondaryContact: _propTypes2.default.object,
  contactsErrors: _propTypes2.default.object,
  unregisterFormField: _propTypes2.default.func,
  untouch: _propTypes2.default.func,
  contacts: _propTypes2.default.object };


PublishContactsBlock.defaultProps = {
  contactsErrors: {} };exports.default =


PublishContactsBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PublishContactsBlock/PublishContactsBlock.js
// module id = 2857
// module chunks = 0